import HomePage from "./Home";

function App() {
  return (
    <div className="App">
      <HomePage />
    </div>
  );
}

export default App;
